// Resume PDF per site language. Languages without their own resume fall back to English.
export const RESUME_PATHS = {
  en: '/resume/Nandan_Priyadarshi_Resume_EN.pdf',
  zh: '/resume/Nandan_Priyadarshi_Resume_ZH.pdf',
};

export const getResumePath = (language) => RESUME_PATHS[language] || RESUME_PATHS.en;
